import { Image } from '@/components/Image'
import { BodyM, HeadingL } from '@/components/Typography'

import { CONTAINER_BLACK_FRIDAY_PROPS } from '../constants'

import { HERO_BLACK_FRIDAY } from './constants'

import { HeroButtonLink, HeroWideContainer, HeroImageContainer } from './styles'

const HeroWideImage = () => (
  <HeroWideContainer {...CONTAINER_BLACK_FRIDAY_PROPS} contentClassName="hero-wide-content">
    <HeroImageContainer>
      <Image {...HERO_BLACK_FRIDAY.image} alt="Central da Black Friday 2022 Serasa " />
    </HeroImageContainer>
    <HeadingL light="solid" tag="h1">
      Na Central da Black Friday Serasa, o juiz da black entra em campo para ajudar você a evitar
      golpes e fraudes.
    </HeadingL>
    <BodyM light="solid">
      A Serasa entra em campo com conteúdos atualizados de golpes, dicas de compra e ainda várias
      soluções Serasa gratuitas para você se prevenir de fraudes e aproveitar a Black Friday com
      segurança.
    </BodyM>
    <HeroButtonLink
      rounded
      aria-label="Assinar o Serasa Premium para se proteger na Black Friday"
      source={HERO_BLACK_FRIDAY.cta.href}
      modifier="solid"
    >
      Proteja-se na Black Friday
    </HeroButtonLink>
  </HeroWideContainer>
)

export default HeroWideImage
